import { Component, inject, input, OnInit } from '@angular/core';
import { ILpCanvasElementContext } from '@features/lp/lp-canvas/lp-canvas.types';
import { LpTriggersService } from '@features/lp/lp-triggers/lp-triggers.service';
import { useCleanup } from '@shared/angular.utils';
import { LpOnTriggerCanvasComponent } from '@typings/lp/generated';

@Component({
  selector: 'lp-on-trigger-canvas-component',
  imports: [],
  templateUrl: './lp-on-trigger-canvas-component.component.html',
  styleUrl: './lp-on-trigger-canvas-component.component.css',
})
export class LpOnTriggerCanvasComponentComponent implements OnInit {
  readonly #lpTriggersService = inject(LpTriggersService);

  comp = input.required<LpOnTriggerCanvasComponent>();
  context = input.required<ILpCanvasElementContext>();

  async ngOnInit(): Promise<void> {
    useCleanup(await this.#lpTriggersService.on(this.comp().listener));
  }
}
